module.exports = __webpack_public_path__ + "static/img/hash.c73b57c4.png";